import { useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { markTokenUpdated } from '../utils/authSession';

const TokenRedirect = () => {

    const {tenant,token} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!tenant || !token) return;

        const currentToken = localStorage.getItem('token');
        if (currentToken !== token) {
            markTokenUpdated(token);
        }
        navigate(`/${tenant}/dashboard`);
    }, [navigate, tenant, token]);
    
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
                <p className="text-gray-600">جاري التحويل إلى لوحة التحكم...</p>
            </div>
        </div>
    )

}

export default TokenRedirect
